import React, { useMemo } from 'react';
import { create } from 'zustand';
import { createDI } from '../di/di';

import style from './indicator.module.scss';

/**
 * Indicator 状態を管理するための DI コンテキスト
 */
export type IndicatorStore = {
  /**
   * 表示ステータス
   */
  showing: boolean;

  /**
   * 表示状態を設定
   */
  show(): void;

  /**
   * 非表示状態を設定
   */
  hide(): void;
};

/**
 * Indicator 状態とアクションを管理するための DI コンテキストを作成
 */
const [Provider, use] = createDI<IndicatorStore>();

/**
 * Indicator 状態とアクション
 */
const defaultIndicatorStore = () => {
  return create<IndicatorStore>((set, get) => {
    return {
      showing: false,
      show: () => set({ showing: true }),
      hide: () => set({ showing: false }),
    };
  });
};

/**
 * Indicatorレイアウト
 * @param children
 * @constructor
 */
export const Indicator: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const showing = use((selector) => selector.showing);

  const showIndicator = useMemo(() => {
    if (showing) {
      return (
          <div className={style.loadingBar}></div>
      );
    }
    return null;
  }, [showing]);

  return (
      <>
        {showIndicator}
        {children}
      </>
  );
};

/**
 * Indicatorプロバイダ
 * @param children
 * @constructor
 */
export const IndicatorProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
      <Provider storeCreator={() => defaultIndicatorStore()}>
        <Indicator>
          {children}
        </Indicator>
      </Provider>
  );
};

export const useIndicatorStore = use;

